import React from 'react';
import { IconProps } from 'components/icons/types';

export const OpenLink = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 11 10"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M9.53397 0.3125H6.68346C6.32326 0.3125 6.03029 0.605469 6.03029 0.965672C6.03029 1.32588 6.32326 1.61884 6.68346 1.61884H7.95955L5.03932 4.53894C4.91444 4.66231 4.8457 4.8259 4.8457 5C4.8457 5.1741 4.91444 5.3377 5.03901 5.46076C5.1633 5.58474 5.32689 5.65317 5.49964 5.65317C5.67239 5.65317 5.83598 5.58474 5.96026 5.46076L8.88079 2.54008V3.81616C8.88079 4.17638 9.17376 4.46935 9.53397 4.46935C9.89417 4.46935 10.1871 4.17638 10.1871 3.81616V0.965669C10.1871 0.605469 9.89417 0.3125 9.53397 0.3125Z"
          fill="#D3D5D8"
        />
        <path
          d="M9.53433 6.01349C9.17412 6.01349 8.88116 6.30646 8.88116 6.66667V8.38114H2.11884V1.61884H3.83333C4.19354 1.61884 4.48651 1.32588 4.48651 0.965672C4.48651 0.605469 4.19354 0.3125 3.83333 0.3125H1.46567C1.10547 0.3125 0.8125 0.605469 0.8125 0.965672V9.03433C0.8125 9.39453 1.10547 9.6875 1.46567 9.6875H9.53433C9.89453 9.6875 10.1875 9.39453 10.1875 9.03433V6.66667C10.1875 6.30646 9.89453 6.01349 9.53433 6.01349Z"
          fill="#D3D5D8"
        />
      </g>
    </svg>
  );
};
